import { BucketId, FileReference } from '@kaizenplatform/belfast-entity';

import State from '../core/State';
import { ProjectChangeType } from '../service/persistent/ProjectChangeWebApi';

export const startFetchingProjectChanges = () => (state: State): State => ({
  ...state,
  projectChange: {
    ...state.projectChange,
    fetching: state.projectChange.fetching + 1,
  },
});

export const finishFetchingProjectChanges = (projectChange: ProjectChangeType | null) => (state: State): State => ({
  ...state,
  projectChange: {
    ...state.projectChange,
    projectChange,
    fetching: state.projectChange.fetching - 1,
  },
});

export const setLatestBriefFiles = (files: Map<BucketId, FileReference[]>) => (state: State): State => ({
  ...state,
  projectChange: {
    ...state.projectChange,
    latestBriefFiles: files,
  },
});

export const setBeforeBriefFiles = (files: Map<BucketId, FileReference[]>) => (state: State): State => ({
  ...state,
  projectChange: {
    ...state.projectChange,
    beforeBriefFiles: files,
  },
});
